import React from 'react';
import { Dialog, DialogContent, Box, Typography, IconButton, Stack, alpha } from '@mui/material';
import { Close as CloseIcon, ScienceOutlined } from '@mui/icons-material';
import AddParameterForm from './AddParameterForm';
import '../style.css';

const AddParameter = ({ open, close, reloadMeasurements, id }) => {
  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth="sm" // Expanded to 'md' to provide room for the parameter preview table
      PaperProps={{
        sx: {
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          overflow: 'hidden',
        },
      }}
    >
      {/* DIALOG HEADER */}
      <Box
        sx={{
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: '#fff',
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: '10px',
              bgcolor: alpha('#2e7d32', 0.1),
              color: 'success.main',
              display: 'flex',
            }}
          >
            <ScienceOutlined fontSize="small" />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ lineHeight: 1.2 }}>
              Add Parameter
            </Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              Configure scientific limits for this parameter
            </Typography>
          </Box>
        </Stack>

        <IconButton
          onClick={close}
          size="small"
          sx={{
            bgcolor: alpha('#000', 0.05),
            '&:hover': { bgcolor: alpha('#d32f2f', 0.1), color: '#d32f2f' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* DIALOG CONTENT */}
      <DialogContent sx={{ p: 4 }}>
        <AddParameterForm closeModal={close} reload={reloadMeasurements} measurementId={id} />
      </DialogContent>
    </Dialog>
  );
};

export default AddParameter;
